export const DEFAULT_CONVERSATION_NAME = 'New Chat';